import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

/**
 * Helper function to check if the application is running on localhost
 * Used for conditional feature availability (e.g., Prompt Playground)
 */
export function isLocalhost(): boolean {
    return window.location.hostname === 'localhost';
}

/**
 * Guard that allows access only when running on localhost
 * Redirects to /pages/tasks if accessed from other domains
 */
export const localhostOnlyGuard: CanActivateFn = () => {
    if (!isLocalhost()) {
        return inject(Router).createUrlTree(['/pages/tasks']);
    }
    return true;
};
